import { useEffect } from 'react';
import { useRecoilCallback } from 'recoil';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import * as H from 'history';

import { getScalyrPath } from 'common/util/location';
import { routeState } from 'components/common/Managers/RouteStateManager.state';
import { CustomLocationState, scrollToHash } from './RouteStateManager.utils';

function PublicRouteStateManager({ history }: RouteComponentProps<{}, {}, CustomLocationState>): JSX.Element {

  const updateURLState = useRecoilCallback(({ set }) => ({ location }: { location: H.Location }): void => {
    scrollToHash(history);
    set(routeState, getScalyrPath(location));
  });

  useEffect(() => {
    history.listen(updateURLState);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const unlisten = updateURLState({ location: history.location });
    // stop the listener when component unmounts
    return unlisten;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <></>;
}

export default withRouter(PublicRouteStateManager);
